import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useLocation, useNavigate } from "react-router-dom";
import TabsNav from "../../../components/TabsNav";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { ContentStyle, DataGridListStyle, HtmlTooltip } from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import { v4 as uuid } from "uuid";
import useFetch from "../../../CustomHooks/useFetch";
import { SSMedHistory } from "../../../Apis/AuthApiServices";
import NoRecords from "../../../components/NoRecords";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { useSelector } from "react-redux";
import { PharmacyDetails } from "../../NewRxPadSingle/PrescriptionSummary";

export default function PrescriptionFilled() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const columns: GridColDef[] = [
    {
      field: "drugName",
      headerName: "Drug",
      width: 250,
      cellClassName: "w45",
      headerClassName: "w45",
      renderCell: ({ row }) => (
        <Typography className="textwrap">
          <Typography
            component="div"
            variant="body2"
            color={row?.validDrug ? "primary" : ""}
            onClick={() => {
              if (row?.validDrug) {
                navigate("/newrxpad", {
                  state: { rowData: row, key: "SSMED" },
                });
              }
            }}
          >
            {row.drugName ?? "N/A"}{" "}
          </Typography>
          {row?.validDrug ? (
            <HtmlTooltip
              placement="right"
              arrow
              title={<SideDrugToolTip row={row} />}
            >
              <IconButton className="tooltip">
                <img src={InfoIcon} alt="Tooltip" loading="lazy" />
              </IconButton>
            </HtmlTooltip>
          ) : (
            <HtmlTooltip placement="right" arrow title={row?.drugName}>
              <IconButton className="tooltip">
                <img src={InfoIcon} alt="Tooltip" loading="lazy" />
              </IconButton>
            </HtmlTooltip>
          )}
        </Typography>
      ),
    },
    {
      field: "pbmBenefitSourceName",
      headerName: "Source",
      width: 150,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "drugIssueDate",
      headerName: "Date",
      width: 100,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    {
      field: "physicianName",
      headerName: "Physician",
      width: 140,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }: any) =>
        row?.prescriberNpi || row.prescriberDea ? (
          <>
            <Typography className={"textwrap"}>
              <Typography component="div" variant="body2">
                {[null, ""].includes(row?.physicianName)
                  ? "Not Available"
                  : row?.physicianName}{" "}
              </Typography>

              <HtmlTooltip
                placement="right"
                arrow
                title={<PhysicianDetails row={row} />}
              >
                <IconButton className="tooltip">
                  <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                </IconButton>
              </HtmlTooltip>
            </Typography>
          </>
        ) : (
          <>
            <Typography component="div" variant="body2">
              {[null, ""].includes(row?.physicianName)
                ? "Not Available"
                : row?.physicianName}{" "}
            </Typography>
          </>
        ),
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 220,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }: any) =>
        row?.pharmacyDetails ? (
          <>
            <Typography className="textwrap">
              <Typography component="div" variant="body2">
                {[null, ""].includes(row?.pharmacyDetails?.pharmacyName)
                  ? "Not Available"
                  : row?.pharmacyDetails?.pharmacyName}{" "}
              </Typography>
              <HtmlTooltip
                placement="right"
                arrow
                title={<PharmacyDetails row={row?.pharmacyDetails} />}
              >
                <IconButton className="tooltip">
                  <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                </IconButton>
              </HtmlTooltip>
            </Typography>
          </>
        ) : (
          <>
            <Typography component="div" variant="body2">
              Not Available
            </Typography>
          </>
        ),
    },
    // {
    //   field: "formularyStatus",
    //   headerName: "Fmlry. Status",
    //   width: 140,
    //   cellClassName: "w15",
    //   headerClassName: "w15",
    // },
    // {
    //   field: "copay",
    //   headerName: "Copay",
    //   width: 130,
    //   cellClassName: "w15",
    //   headerClassName: "w15",
    // },
  ];

  const patientId = sessionStorage.getItem("patientId");
  const Params = {
    doctorId:
      UserServiceState?.profileGroup > 6
        ? localStorage.getItem("SupervisorDoctorId")
        : localStorage.getItem("doctorId"),
    patientId: patientId,
    concent: state?.Consent,
    pageNumber: page,
  };
  const { data, loading, error }: any = useFetch(Params, SSMedHistory, [page]);

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  if (loading) {
    return (
      <>
        <Box
          style={{
            width: "100%",
            height: 300,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color={"primary"}
            component="div"
            fontWeight={500}
          >
            Please wait while we fetch the Rx history from Surescripts
          </Typography>
          <CircularProgress color="primary" />
        </Box>
      </>
    );
  }
  return (
    <>
      <TabsNav />{" "}
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                columns={columns}
                rows={data[0]?.items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                paginationMode="server"
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                getRowId={(row) => row.personId ?? uuid()}
                pagination
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12} className="btns">
            <YSButton
              onClick={() => {
                navigate("/ssmedicationhistory");
              }}
              className=""
              children={"Back To SS Medication History"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
          <Grid item xs={12}>
            <Typography color={"error"} variant={"body2"}>
              Certain information may not be available or accurate in this
              report, including items that the patient asked not be disclosed
              due to patient privacy concerns, over-the-counter medications, low
              cost prescriptions, prescriptions paid for by the patient or
              non-participating sources, or errors in insurance claims
              information. The provider should independently verify medication
              history with the patient
            </Typography>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}

const SideDrugToolTip = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      {row?.drugName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Drug Description:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.drugName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.instructions && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Drug Instructions:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.instructions}
            </Typography>
          </Grid>
        </>
      )}
      {row?.daysSupply && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Days Supply:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.daysSupply}
            </Typography>
          </Grid>
        </>
      )}
      {row?.quantity && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Quantity:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.quantity}
            </Typography>
          </Grid>
        </>
      )}
      {row?.clinicInformationQualifier && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Clinic Information:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.clinicInformationQualifier}
            </Typography>
          </Grid>
        </>
      )}
      {row?.diagnosisQualifier && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Diagnosis Qualifier:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.diagnosisQualifier}
            </Typography>
          </Grid>
        </>
      )}
      {row?.diagnosisCode && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Diagnosis Code:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.diagnosisCode}
            </Typography>
          </Grid>
        </>
      )}
      {row?.diagnosisDescription && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Diagnosis Description:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.diagnosisDescription}
            </Typography>
          </Grid>
        </>
      )}
      {row?.refills && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Refills Remaining:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.refills}
            </Typography>
          </Grid>
        </>
      )}
      {row?.drugIssueDate && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Last Fill Date:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.drugIssueDate}
            </Typography>
          </Grid>
        </>
      )}
      {row?.substitutionCode && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Substitutions:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.substitutionCode}
            </Typography>
          </Grid>
        </>
      )}
      {row?.priorAuthorization && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prior Authorization:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.priorAuthorization}
            </Typography>
          </Grid>
        </>
      )}
      {row?.priorAuthorizationStatus && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prior Authorization Status:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.priorAuthorizationStatus}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const PhysicianDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      {row?.physicianName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Physician Name:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.physicianName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.prescriberDea && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prescriber DEA:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.prescriberDea}
            </Typography>
          </Grid>
        </>
      )}
      {row?.prescriberNpi && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prescriber NPI:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.prescriberNpi}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};
